import { Inbox } from "lucide-react";

export default function TrackEmpty({ title, message, testid }) {
  return (
    <div data-testid={testid || "track-empty"}>
      <h1 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl mb-2">{title}</h1>
      <div className="mt-6 border border-white/10 bg-[#121212] flex flex-col items-center justify-center text-center py-20 px-6">
        <div className="w-14 h-14 rounded-full border border-white/15 flex items-center justify-center mb-5"><Inbox size={22} className="text-white/40" /></div>
        <p className="text-white/50 text-sm max-w-md leading-relaxed">{message}</p>
        <span className="mt-5 font-mono-accent text-[10px] tracking-[0.25em] uppercase text-white/25">Coming in a later phase</span>
      </div>
    </div>
  );
}
